<div class="modal-header">
  <h4 class="modal-title">Захранване на сметка</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <span class="form-label">Начин на плащане*</span>
      @for (option of invoicePaymentOptions; track option.invoicePaymentOptionId) {
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            [id]="'paymentOption' + option.invoicePaymentOptionId"
            formControlName="invoicePaymentOptionId"
            [value]="option.invoicePaymentOptionId">
          <label
            class="form-check-label"
            [for]="'paymentOption' + option.invoicePaymentOptionId">
            {{ option.invoicePaymentOptionName }}
          </label>
        </div>
      }
    </fieldset>
    <fieldset class="mb-4">
      <label for="amount" class="mb-0 form-label">Сума в лева*</label>
      <input
        id="amount"
        type="number"
        formControlName="amount"
        class="form-control"
        placeholder="Въведете сума..."
        aria-label="Сума"
        [class.is-valid]="amount?.touched && amount?.valid"
        [class.is-invalid]="amount?.touched && amount?.invalid">
      <p class="invalid-feedback m-0">Задължително поле по-голямо или равно на 1 лев!</p>
    </fieldset>
  </form>
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Продължи</span>
  </button>
</div>
